(function () {
  "use strict";

  var SMS_CONSENT_TEXT = 'By checking this box, you agree to receive recurring automated marketing text messages from Orthotic Shop at the mobile number provided, including exclusive offers, rewards promotions, product news, and seasonal sales. Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply. Reply STOP to cancel and HELP for help. View our <a href="https://orthoticshop.com/policies/terms-of-service" target="_blank" rel="noopener noreferrer">Terms of Service</a> and <a href="https://orthoticshop.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.';
  var defaults = {
    endpoint: "https://emails.orthoticshop.com/back-in-stock.php",
    source: "shopify_product_back_in_stock",
    notifyButtonText: "Notify Me",
    soldOutText: "Sold out",
    modalTitle: "Get the latest product news and exclusive offers",
    emailPlaceholder: "Enter your email address",
    phonePlaceholder: "Mobile number optional",
    smsLabel: "Text me product news and exclusive promotional offers from Orthotic Shop.",
    smsConsentText: SMS_CONSENT_TEXT,
    submitText: "Notify Me",
    successText: "Thanks. We will email you if this item comes back in stock.",
    smsSuccessText: "You are also signed up for SMS product news and promotional updates.",
    hideSoldOutButton: true,
    selector: 'product-form form[action*="/cart/add"], form[action*="/cart/add"]'
  };
  var config = extend(defaults, window.emailBroBackInStockConfig || {});
  var state = {
    modal: null,
    activeForm: null,
    activeVariant: null,
    product: null,
    observed: [],
    updateTimer: null
  };

  function extend(base, extra) {
    var out = {};
    Object.keys(base).forEach(function (key) { out[key] = base[key]; });
    Object.keys(extra || {}).forEach(function (key) { out[key] = extra[key]; });
    return out;
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (ch) {
      return {"&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;"}[ch];
    });
  }

  function text(el) {
    return el && el.textContent ? el.textContent.replace(/\s+/g, " ").trim() : "";
  }

  function normalizeId(value) {
    value = String(value || "").trim();
    return value.replace(/^gid:\/\/shopify\/ProductVariant\//, "");
  }

  function parseProductJson() {
    var candidates = [];
    if (window.meta && window.meta.product) candidates.push(window.meta.product);
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      candidates.push(window.ShopifyAnalytics.meta.product);
    }
    document.querySelectorAll('variant-selects script[type="application/json"], variant-radios script[type="application/json"], product-info script[type="application/json"], script[type="application/json"][data-product-json]').forEach(function (script) {
      try {
        var parsed = JSON.parse(script.textContent || "");
        if (parsed) candidates.push(parsed);
      } catch (e) {
      }
    });
    for (var i = 0; i < candidates.length; i++) {
      var item = candidates[i];
      if (item && item.variants && item.variants.length) return item;
      if (item && item.product && item.product.variants && item.product.variants.length) return item.product;
    }
    return {};
  }

  function productData() {
    if (state.product) return state.product;
    state.product = parseProductJson();
    return state.product;
  }

  function currentVariantId(form) {
    var input = form && form.querySelector('[name="id"]');
    if (input && input.value) return normalizeId(input.value);
    try {
      var urlVariant = new URLSearchParams(window.location.search).get("variant") || "";
      if (urlVariant) return normalizeId(urlVariant);
    } catch (e) {
    }
    return "";
  }

  function variantById(id) {
    id = normalizeId(id);
    if (!id) return null;
    var product = productData();
    var variants = product && product.variants ? product.variants : [];
    for (var i = 0; i < variants.length; i++) {
      if (normalizeId(variants[i].id) === id) return variants[i];
    }
    return null;
  }

  function productRootFor(form) {
    return form && form.closest ? form.closest("product-info") : null;
  }

  function selectedVariantFromDom(form) {
    var root = productRootFor(form) || document;
    var el = root.querySelector('variant-selects [data-selected-variant], variant-radios [data-selected-variant]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || el.innerHTML || "null");
    } catch (e) {
      return null;
    }
  }

  function variantAvailable(variant) {
    if (!variant) return null;
    if (variant.inventory_policy === "continue" || variant.inventoryPolicy === "continue" || variant.inventoryPolicy === "CONTINUE") return true;
    if (typeof variant.available === "boolean") return variant.available;
    if (typeof variant.inventory_quantity === "number") return variant.inventory_quantity > 0;
    if (typeof variant.inventoryQuantity === "number") return variant.inventoryQuantity > 0;
    return null;
  }

  function findSubmitButton(form) {
    return form ? form.querySelector('button[name="add"], button[type="submit"], input[type="submit"]') : null;
  }

  function buttonLooksSoldOut(button) {
    var label = button ? ((button.value || "") + " " + text(button)).toLowerCase() : "";
    return label.indexOf("sold out") !== -1 || label.indexOf("unavailable") !== -1;
  }

  function formIsOutOfStock(form) {
    var variant = selectedVariantFromDom(form) || variantById(currentVariantId(form));
    var available = variantAvailable(variant);
    if (available === false) return {out: true, variant: variant};
    return {out: false, variant: variant};
  }

  function notifyButtonFor(form, submitButton) {
    if (!form) return null;
    injectCss();
    var existing = form.querySelector("[data-emailbro-bis-notify]");
    if (existing) return existing;
    var button = document.createElement("button");
    button.type = "button";
    button.className = "emailbro-bis-notify product-form__submit button button--full-width button--secondary";
    button.setAttribute("data-emailbro-bis-notify", "1");
    button.hidden = true;
    button.style.display = "none";
    button.innerHTML = "<span>" + escapeHtml(config.notifyButtonText) + "</span>";
    button.addEventListener("click", notifyClick, true);
    if (submitButton && submitButton.parentNode) {
      submitButton.parentNode.insertBefore(button, submitButton.nextSibling);
    } else {
      form.appendChild(button);
    }
    return button;
  }

  function hideNativeButton(button) {
    if (!button || !config.hideSoldOutButton) return;
    if (!button.hasAttribute("data-emailbro-bis-original-display")) {
      button.setAttribute("data-emailbro-bis-original-display", button.style.display || "");
    }
    if (button.style.display === "none") return;
    button.style.display = "none";
  }

  function showNativeButton(button) {
    if (!button || !button.hasAttribute("data-emailbro-bis-original-display")) return;
    button.style.display = button.getAttribute("data-emailbro-bis-original-display") || "";
    button.removeAttribute("data-emailbro-bis-original-display");
  }

  function hideNotifyButton(form, submitButton) {
    var button = form ? form.querySelector("[data-emailbro-bis-notify]") : null;
    if (button) {
      if (!button.hidden) button.hidden = true;
      if (button.classList.contains("is-visible")) button.classList.remove("is-visible");
      if (button.style.display !== "none") button.style.display = "none";
      button._emailBroBisForm = null;
      button._emailBroBisVariant = null;
      button.removeAttribute("data-emailbro-bis-variant-id");
    }
    showNativeButton(submitButton);
  }

  function showNotifyButton(form, submitButton, variant) {
    var button = notifyButtonFor(form, submitButton);
    if (!button) return;
    var variantId = variant && variant.id ? normalizeId(variant.id) : currentVariantId(form);
    var isAlreadyVisible = !button.hidden && button.classList.contains("is-visible") &&
      normalizeId(button.getAttribute("data-emailbro-bis-variant-id") || "") === normalizeId(variantId);
    if (!isAlreadyVisible) {
      if (button.hidden) button.hidden = false;
      if (!button.classList.contains("is-visible")) button.classList.add("is-visible");
      if (button.style.display) button.style.display = "";
      if (text(button) !== config.notifyButtonText) button.innerHTML = "<span>" + escapeHtml(config.notifyButtonText) + "</span>";
      button.setAttribute("data-emailbro-bis-variant-id", variantId);
    }
    if (button.disabled) button.disabled = false;
    button._emailBroBisForm = form;
    button._emailBroBisVariant = variant || null;
    hideNativeButton(submitButton);
  }

  function notifyClick(event) {
    var button = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    openModal(button._emailBroBisForm, button._emailBroBisVariant || null);
  }

  function updateForm(form) {
    updateFormWithVariant(form, null);
  }

  function updateFormWithVariant(form, variant) {
    var button = findSubmitButton(form);
    if (!button) return;
    var info = variant ? {out: variantAvailable(variant) === false, variant: variant} : formIsOutOfStock(form);
    if (info.out) {
      showNotifyButton(form, button, info.variant);
    } else {
      hideNotifyButton(form, button);
    }
  }

  function scheduleUpdate() {
    clearTimeout(state.updateTimer);
    state.updateTimer = setTimeout(updateAll, 120);
  }

  function hideNotifyDuringVariantTransition() {
    document.querySelectorAll("[data-emailbro-bis-notify]").forEach(function (button) {
      if (button.hidden && !button.classList.contains("is-visible") && button.style.display === "none") return;
      button.hidden = true;
      button.classList.remove("is-visible");
      button.style.display = "none";
      button.removeAttribute("data-emailbro-bis-variant-id");
    });
  }

  function updateAll() {
    document.querySelectorAll(config.selector).forEach(updateForm);
  }

  function formForSection(sectionId) {
    var root = sectionId ? document.querySelector('product-info[data-section="' + sectionId + '"]') : null;
    return root ? root.querySelector(config.selector) : document.querySelector(config.selector);
  }

  function selectedOptions(variant) {
    if (!variant) return "";
    if (variant.title && variant.title !== "Default Title") return variant.title;
    if (variant.public_title) return variant.public_title;
    if (variant.options && variant.options.length) return variant.options.join(" / ");
    return "";
  }

  function productTitle() {
    var product = productData();
    return product.title || text(document.querySelector("h1")) || "Selected item";
  }

  function productImage() {
    var img = document.querySelector(".product__media img, [data-media-id] img, .product-media img, img#productInfoImage");
    if (img) return img.currentSrc || img.src || "";
    return "";
  }

  function payloadFor(form, variant) {
    var product = productData();
    var variantId = variant && variant.id ? normalizeId(variant.id) : currentVariantId(form);
    var sku = variant && variant.sku ? variant.sku : "";
    return {
      shopify_product_id: product && product.id ? product.id : "",
      shopify_variant_id: variantId,
      sku: sku,
      product_name: productTitle(),
      variant_title: selectedOptions(variant),
      product_url: window.location.pathname + window.location.search,
      product_image: productImage(),
      source: config.source,
      source_url: window.location.href,
      referrer: document.referrer || ""
    };
  }

  function ensureModal() {
    if (state.modal && !state.modal.querySelector("[name=email]")) {
      state.modal.parentNode.removeChild(state.modal);
      state.modal = null;
    }
    if (state.modal) return state.modal;
    var wrap = document.createElement("div");
    wrap.id = "emailbro-bis-modal";
    wrap.innerHTML = [
      '<div class="emailbro-bis-backdrop" data-emailbro-close></div>',
      '<div class="emailbro-bis-dialog" role="dialog" aria-modal="true" aria-labelledby="emailbro-bis-title">',
      '<button class="emailbro-bis-close" type="button" aria-label="Close" data-emailbro-close>&times;</button>',
      '<h2 id="emailbro-bis-title"></h2>',
      '<div class="emailbro-bis-product"></div>',
      '<form class="emailbro-bis-form" novalidate>',
      '<input type="text" name="website" tabindex="-1" autocomplete="off" aria-hidden="true" class="emailbro-bis-hp">',
      '<label>Email address <input type="email" name="email" required autocomplete="email"></label>',
      '<label>Mobile number <input type="tel" name="phone" autocomplete="tel"></label>',
      '<label class="emailbro-bis-sms"><input type="checkbox" name="sms_consent" value="1"> <span></span></label>',
      '<p class="emailbro-bis-legal"></p>',
      '<div class="emailbro-bis-error" role="alert"></div>',
      '<button class="emailbro-bis-submit" type="submit"></button>',
      '</form>',
      '</div>'
    ].join("");
    document.body.appendChild(wrap);
    injectCss();
    wrap.querySelector("[name=email]").placeholder = config.emailPlaceholder;
    wrap.querySelector("[name=phone]").placeholder = config.phonePlaceholder;
    wrap.querySelector(".emailbro-bis-sms span").textContent = config.smsLabel;
    wrap.querySelector(".emailbro-bis-legal").innerHTML = config.smsConsentText;
    wrap.querySelector(".emailbro-bis-submit").textContent = config.submitText;
    wrap.addEventListener("click", function (event) {
      if (event.target && event.target.hasAttribute("data-emailbro-close")) closeModal();
    });
    wrap.querySelector("form").addEventListener("submit", submitModal);
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeModal();
    });
    state.modal = wrap;
    return wrap;
  }

  function injectCss() {
    if (document.getElementById("emailbro-bis-css")) return;
    var style = document.createElement("style");
    style.id = "emailbro-bis-css";
    style.textContent = [
      ".emailbro-bis-notify{display:none!important;cursor:pointer!important}",
      ".emailbro-bis-notify.is-visible{display:flex!important}",
      ".emailbro-bis-notify[hidden]{display:none!important}",
      "#emailbro-bis-modal{display:none;position:fixed;z-index:2147483000;inset:0;font-family:Arial,Helvetica,sans-serif;color:#172033}",
      "#emailbro-bis-modal.is-open{display:block}",
      ".emailbro-bis-backdrop{position:absolute;inset:0;background:rgba(15,23,42,.52)}",
      ".emailbro-bis-dialog{position:relative;box-sizing:border-box;width:min(94vw,520px);max-height:90vh;overflow:auto;margin:5vh auto;background:#fff;border:1px solid #dbe5ef;border-radius:8px;padding:24px;box-shadow:0 18px 48px rgba(15,23,42,.32)}",
      ".emailbro-bis-close{position:absolute;top:10px;right:12px;border:0;background:transparent;color:#334155;font-size:28px;line-height:1;cursor:pointer}",
      "#emailbro-bis-title{margin:0 32px 14px 0;font:700 23px/1.2 Arial,Helvetica,sans-serif;color:#0f172a}",
      ".emailbro-bis-product{border:1px solid #e5e7eb;background:#f8fafc;border-radius:6px;padding:12px;margin:0 0 16px;font:14px/1.45 Arial,Helvetica,sans-serif}",
      ".emailbro-bis-product strong{display:block;color:#0f172a;margin-bottom:4px}",
      ".emailbro-bis-form label{display:block;margin:0 0 12px;font:700 14px/1.3 Arial,Helvetica,sans-serif;color:#334155}",
      ".emailbro-bis-form input[type=email],.emailbro-bis-form input[type=tel]{box-sizing:border-box;width:100%;height:42px;margin-top:5px;border:1px solid #cbd5e1;border-radius:5px;padding:0 11px;font:15px Arial,Helvetica,sans-serif}",
      ".emailbro-bis-sms{display:flex!important;gap:9px;align-items:flex-start;font-weight:400!important}",
      ".emailbro-bis-sms input{margin-top:2px;flex:0 0 auto}",
      ".emailbro-bis-legal{margin:0 0 14px;font:12px/1.45 Arial,Helvetica,sans-serif;color:#64748b}",
      ".emailbro-bis-error{display:none;margin:0 0 12px;color:#991b1b;font:13px/1.4 Arial,Helvetica,sans-serif}",
      ".emailbro-bis-submit{height:44px;border:0;border-radius:5px;background:#0f766e;color:#fff;padding:0 18px;font:700 15px Arial,Helvetica,sans-serif;cursor:pointer}",
      ".emailbro-bis-submit[disabled]{opacity:.65;cursor:wait}",
      ".emailbro-bis-hp{position:absolute!important;left:-10000px!important;width:1px!important;height:1px!important;overflow:hidden!important}",
      "@media(max-width:540px){.emailbro-bis-dialog{width:calc(100vw - 24px);margin:18px 12px;padding:20px}}"
    ].join("\n");
    document.head.appendChild(style);
  }

  function openModal(form, variant) {
    var modal = ensureModal();
    state.activeForm = form;
    state.activeVariant = variant || variantById(currentVariantId(form));
    var options = selectedOptions(state.activeVariant);
    var sku = state.activeVariant && state.activeVariant.sku ? state.activeVariant.sku : "";
    modal.querySelector("#emailbro-bis-title").textContent = config.modalTitle;
    modal.querySelector(".emailbro-bis-product").innerHTML = "<strong>" + escapeHtml(productTitle()) + "</strong>" +
      (options ? "<div>Options: " + escapeHtml(options) + "</div>" : "") +
      (sku ? "<div>SKU: " + escapeHtml(sku) + "</div>" : "");
    modal.querySelector(".emailbro-bis-error").style.display = "none";
    modal.querySelector(".emailbro-bis-error").textContent = "";
    modal.querySelector("form").reset();
    modal.classList.add("is-open");
    setTimeout(function () {
      var email = modal.querySelector("[name=email]");
      if (email) email.focus();
    }, 30);
  }

  function closeModal() {
    if (state.modal) state.modal.classList.remove("is-open");
  }

  function setError(message) {
    var err = state.modal.querySelector(".emailbro-bis-error");
    err.textContent = message || "Could not save that request. Please try again.";
    err.style.display = "block";
  }

  function submitModal(event) {
    event.preventDefault();
    var formEl = event.currentTarget;
    var button = formEl.querySelector(".emailbro-bis-submit");
    var email = formEl.email.value.trim();
    var phone = formEl.phone.value.trim();
    var smsConsent = formEl.sms_consent.checked;
    if (!email) {
      setError("Please enter your email address.");
      return;
    }
    if (smsConsent && !phone) {
      setError("Please enter a mobile number to sign up for text alerts.");
      return;
    }
    button.disabled = true;
    button.textContent = "Saving...";
    var payload = payloadFor(state.activeForm, state.activeVariant);
    payload.email = email;
    payload.phone = phone;
    payload.sms_consent = smsConsent ? "1" : "0";
    payload.sms_consent_text = config.smsConsentText;
    payload.website = formEl.website.value.trim();

    try {
      fetch(config.endpoint, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().catch(function () { return {}; });
      }).then(function (data) {
        if (data && data.ok) {
          var message = data.message || config.successText;
          if (smsConsent) message += " " + config.smsSuccessText;
          formEl.innerHTML = '<div style="font:16px/1.5 Arial,Helvetica,sans-serif;color:#0f172a;"><strong>Success.</strong><br>' + escapeHtml(message) + '</div>';
          return;
        }
        setError((data && data.message) || "Could not save that request. Please try again.");
        button.disabled = false;
        button.textContent = config.submitText;
      }).catch(function () {
        setError("Could not save that request. Please try again.");
        button.disabled = false;
        button.textContent = config.submitText;
      });
    } catch (e) {
      setError("Could not save that request. Please try again.");
      button.disabled = false;
      button.textContent = config.submitText;
    }
  }

  function observeForms() {
    document.querySelectorAll(config.selector).forEach(function (form) {
      if (form.getAttribute("data-emailbro-bis-observed") === "1") return;
      form.setAttribute("data-emailbro-bis-observed", "1");
      try {
        var observer = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var target = mutations[i].target;
            if (target && target.closest && target.closest("[data-emailbro-bis-notify]")) continue;
            scheduleUpdate();
            return;
          }
        });
        observer.observe(form, {childList: true, subtree: true, attributes: true, attributeFilter: ["disabled", "class", "aria-disabled"]});
        state.observed.push(observer);
      } catch (e) {
      }
    });
  }

  function boot() {
    injectCss();
    observeForms();
    updateAll();
    document.addEventListener("change", function () {
      hideNotifyDuringVariantTransition();
      scheduleUpdate();
    }, true);
    document.addEventListener("variant:change", function () {
      hideNotifyDuringVariantTransition();
      scheduleUpdate();
    }, true);
    document.addEventListener("os:variant-updated", function (event) {
      var detail = event.detail || {};
      var form = formForSection(detail.sectionId || "");
      if (!form) {
        scheduleUpdate();
        return;
      }
      observeForms();
      updateFormWithVariant(form, detail.variant || null);
    }, true);
    document.addEventListener("product-info:loaded", function () {
      state.product = null;
      hideNotifyDuringVariantTransition();
      observeForms();
      scheduleUpdate();
    }, true);
    document.addEventListener("shopify:section:load", function () {
      state.product = null;
      observeForms();
      scheduleUpdate();
    });
  }

  window.EmailBroBackInStock = {
    refresh: function () {
      state.product = null;
      observeForms();
      updateAll();
    },
    updateVariant: function (sectionId, variant) {
      var form = formForSection(sectionId || "");
      if (!form) return;
      state.product = null;
      observeForms();
      updateFormWithVariant(form, variant || null);
    },
    open: openModal
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
